import { render, staticRenderFns } from "./MethodRevolutV1.vue?vue&type=template&id=7bcc557c&scoped=true&"
import script from "./MethodRevolutV1.vue?vue&type=script&lang=js&"
export * from "./MethodRevolutV1.vue?vue&type=script&lang=js&"
import style0 from "./MethodRevolutV1.vue?vue&type=style&index=0&id=7bcc557c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcc557c",
  null
  
)

export default component.exports